<template>
    <div class="h-100 columns is-gapless">
        <div class="column is-7 gradiend-background has-text-white">
            <div class="h-100 columns is-vcentered">
                <div class="is-offset-1 column">
                    <p>
                        <img
                            src="@/assets/icons/LOGO-OGMIA-WHITE.svg"
                            width="200"
                            alt="white-logo"
                        />
                    </p>
                    <h2 class="title is-2 mt-2 has-text-white">
                        {{ $t("behind-the-scene.welcome") }}
                    </h2>
                    <p>
                        <Icon family="fal" name="fa-check" />{{
                            $t("behind-the-scene.safe-environment")
                        }}
                    </p>
                    <p>
                        <Icon family="fal" name="fa-check" />{{
                            $t("behind-the-scene.encrypted-data")
                        }}
                    </p>
                    <p>
                        <Icon family="fal" name="fa-check" />{{
                            $t("behind-the-scene.recorded-data")
                        }}
                    </p>
                </div>
            </div>
        </div>
        <div class="h-100 column has-background-white">
            <div class="settings-column">
                <div
                    v-if="isLogged && roomAdmin !== ''"
                    class="has-text-centered pb-4"
                >
                    <p class="label-blue">
                        {{ $t("behind-the-scene.room-admin") }}
                    </p>
                    <p>{{ roomAdmin }}</p>
                </div>
                <VideoStream
                    ref="videoStream"
                    :isSmall="false"
                    :stream="localStream"
                    :muted="!enabledMicrophone"
                    :blockedCamera="!enabledCamera"
                    :name="name"
                />
                <div class="settings-column">
                    <div class="field" v-if="isPreviousRoom">
                        <label class="label label-blue">{{
                            $t("behind-the-scene.cedula-or-passport")
                        }}</label>

                        <div class="control">
                            <input
                                :disabled="isLogged || readonlyName"
                                @keyup.enter="join"
                                v-model="name"
                                class="input is-radiusless"
                                type="text"
                            />
                        </div>
                        <p
                            v-if="haveIdentificationError"
                            class="help is-danger"
                        >
                            {{ idError }}
                        </p>
                    </div>
                    <div class="field">
                        <div class="control">
                            <label class="label label-blue">{{
                                $t("behind-the-scene.camera")
                            }}</label>
                            <div class="field has-addons">
                                <div class="control is-expanded">
                                    <div class="select is-fullwidth">
                                        <select
                                            class="is-radiusless"
                                            v-model="cameraId"
                                            @change="changeCamera"
                                            :disabled="!enabledCamera"
                                        >
                                            <option
                                                v-for="camera in cameras"
                                                :key="camera.deviceId"
                                                :value="camera.deviceId"
                                            >
                                                {{ camera.label }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="control">
                                    <button
                                        class="button is-primary is-radiusless"
                                        @click="toggleCamera"
                                    >
                                        <Icon
                                            v-if="enabledCamera"
                                            family="fal"
                                            name="fa-webcam"
                                            class="is-white"
                                        />
                                        <Icon
                                            v-else
                                            family="fal"
                                            name="fa-webcam-slash"
                                            class="is-white"
                                        />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="field">
                        <label class="label label-blue">{{
                            $t("behind-the-scene.microphone")
                        }}</label>
                        <div class="field has-addons">
                            <div class="control is-expanded">
                                <div class="select is-fullwidth">
                                    <select
                                        class="is-radiusless"
                                        v-model="microphoneId"
                                        @change="changeMicrophone"
                                        :disabled="!enabledMicrophone"
                                    >
                                        <option
                                            v-for="microphone in microphones"
                                            :key="microphone.deviceId"
                                            :value="microphone.deviceId"
                                        >
                                            {{ microphone.label }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="control">
                                <button
                                    class="button is-primary is-radiusless"
                                    @click="toggleMicrophone"
                                >
                                    <Icon
                                        v-if="enabledMicrophone"
                                        family="fal"
                                        name="fa-microphone"
                                        class="is-white"
                                    />
                                    <Icon
                                        v-else
                                        family="fal"
                                        name="fa-microphone-slash"
                                        class="is-white"
                                    />
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="field is-grouped is-grouped-right mt-2">
                        <div class="control">
                            <button
                                v-if="isPreviousRoom"
                                @click="join"
                                class="button is-primary is-radiusless"
                                :disabled="disabledAccess || loadingJoin"
                            >
                                <span>{{ $t("behind-the-scene.join") }}</span>
                                <Icon family="fal" name="fa-phone-plus" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <NotValidRoomModal :show="showNotValidRoom" />
    </div>
</template>

<script>
import VideoStream from "./VideoStream.vue";
import NotValidRoomModal from "./NotValidRoomModal.vue";

import * as SignalR from "@microsoft/signalr";

import { RepositoryFactory } from "@/services/api";
import { mapActions, mapGetters } from "vuex";

var DetectRTC = require("detectrtc");
const defaultMediaStreamConstraints = {
    audio: {
        echoCancellation: true,
        noiseSuppression: true,
        autoGainControl: true,
    },
    video: {
        width: { max: 640 },
    },
};

export default {
    name: "behind-the-scene",
    components: {
        VideoStream,
        NotValidRoomModal,
    },
    props: {
        roomId: { type: String, required: true },
        isPreviousRoom: { type: Boolean, default: true },
    },
    data() {
        return {
            name: "",
            identificationType: "",
            identification: "",
            idError: "",
            cameraId: null,
            microphoneId: null,
            room: null,
            readonlyName: false,

            cameras: [],
            microphones: [],

            enabledCamera: true,
            enabledMicrophone: true,

            localStream: null,
            mediaStreamConstraints: { ...defaultMediaStreamConstraints },
            loadingJoin: false,

            showNotValidRoom: false,

            signalRSocket: null,
        };
    },
    async mounted() {
        try {
            await this.startMediaStream();
        } catch (error) {
            alert(
                "Error configurando su cámara, refresque la pantalla e intente de nuevo, de lo contrario, por favor asegúrese de permitir el acceso de su cámara."
            );
            window.console.log(error);
        }
        this.name = this.userName;
        this.identificationType = this.userIdentificationType;
        this.identification = this.userIdentification;
        this.loadRoomInfo();
        this.checkBrowserSupport();

        if (!this.oidcIsAuthenticated && "require_auth" in this.$route.query) {
            await this.authenticateOidc(this.$route.path);
            return;
        }

        let environment = this.$route.query.environment;
        if (!this.oidcIsAuthenticated && environment === "recognition-cau") {
            let cedula = this.$route.query.cedula;
            this.name = cedula;
            this.identificationType = "Cedula";
            this.identification = cedula;
            this.readonlyName = true;
        } else if (!this.oidcIsAuthenticated) {
            let cedula = this.$route.query.cedula;
            this.name = cedula;
            this.identificationType = "Cedula";
            this.identification = cedula;
            this.readonlyName = true;
        }

        await this.notifyPreRoomJoin();
        if (!this.isLogged) {
            await this.signalRInitialize();
            await this.signalRSocket.invoke(
                "OnlineUserJoinPreRoom",
                this.$route.query.cedula
            );
        }
    },
    async beforeDestroy() {
        this.stopMediaStream();

        if (!this.isLogged && this.signalRSocket !== null) {
            let socket = this.signalRSocket;
            this.signalRSocket = null;
            await socket.stop();
        }
    },
    computed: {
        ...mapGetters("browserCompatibility", ["getCompatibilities"]),
        ...mapGetters("oidcStore", ["oidcIsAuthenticated", "oidcUser"]),
        isLogged() {
            return this.oidcIsAuthenticated;
        },
        userName() {
            let user = this.oidcUser;
            if (user !== null) {
                return user.given_name ?? user.name;
            }
            return "";
        },
        userIdentificationType() {
            let user = this.oidcUser;
            if (user !== null) {
                return user.cedula ? "Cedula" : "Passport";
            }
            return "";
        },
        userIdentification() {
            let user = this.oidcUser;
            if (user !== null) {
                return user.cedula ?? user.passport;
            }
            return "";
        },
        disabledAccess() {
            return this.name === "";
        },
        someCompatibilityWrong() {
            let compatibilities = this.getCompatibilities;
            let wrongs = compatibilities.filter((c) => !c.correct);
            return wrongs.length > 0;
        },
        haveIdentificationError() {
            return this.idError !== "";
        },
        roomAdmin() {
            return this.room !== null ? this.room.admin.name : "";
        },
    },
    methods: {
        ...mapActions("conference", ["setConference"]),
        ...mapActions("browserCompatibility", ["addCompatibility", "open"]),
        ...mapActions("oidcStore", ["authenticateOidc"]),
        async signalRInitialize() {
            try {
                const socket = new SignalR.HubConnectionBuilder()
                    .withUrl(process.env.VUE_APP_ONLINE_HUB)
                    .withAutomaticReconnect()
                    .build();

                socket.connection.onclose = async (error) => {
                    if (error !== undefined) this.$log(error);

                    this.$log("Reconnecting...");
                    this.signalRSocket = false;
                    await this.signalRInitialize();
                };

                await socket.start();

                this.signalRSocket = socket;
            } catch (err) {
                this.$log("Error, reconnecting...");

                setTimeout(() => {
                    this.signalRInitialize();
                }, 1000);
            }
        },
        async initialiceDevices() {
            this.cameras = await this.getCameras();
            this.microphones = await this.getMicrophones();
            if (this.cameras.length > 0) {
                this.cameraId = this.cameras[0].deviceId;
                if (this.cameraId !== "") {
                    this.mediaStreamConstraints.video.deviceId = {
                        exact: this.cameraId,
                    };
                }
            }

            if (this.microphones.length > 0) {
                this.microphoneId = this.microphones[0].deviceId;
                if (this.microphoneId !== "") {
                    this.mediaStreamConstraints.audio.deviceId = {
                        exact: this.microphoneId,
                    };
                }
            }
            this.microphone = this.microphones[0]; // TODO
            window.console.log(this.mediaStreamConstraints);
            await this.startMediaStream();
        },
        async loadRoomInfo() {
            let response = await RepositoryFactory.conference.get({
                roomId: this.roomId,
            });
            this.room = response.data;
        },
        checkBrowserSupport() {
            DetectRTC.load(() => {
                this.checkBrowserCompatibility();
                if (!this.someCompatibilityWrong) {
                    this.initialiceDevices();
                } else {
                    this.open({ allowClose: false });
                }
            });
        },
        checkBrowserCompatibility() {
            window.console.log(DetectRTC);
            window.console.log("Browser", DetectRTC.browser);
            this.addCompatibility({
                titleTag: "isGetUserMediaSupported",
                correct: DetectRTC.isGetUserMediaSupported,
            });
            this.addCompatibility({
                titleTag: "hasWebcam",
                correct: DetectRTC.hasWebcam,
            });
            this.addCompatibility({
                titleTag: "hasMicrophone",
                correct: DetectRTC.hasMicrophone,
            });
            this.addCompatibility({
                titleTag: "isWebsiteHasWebcamPermissions",
                correct: DetectRTC.isWebsiteHasWebcamPermissions,
            });
            this.addCompatibility({
                titleTag: "isWebsiteHasMicrophonePermissions",
                correct: DetectRTC.isWebsiteHasMicrophonePermissions,
            });
            this.addCompatibility({
                titleTag: "isWebSocketsSupported",
                correct: DetectRTC.isWebSocketsSupported,
            });
            this.addCompatibility({
                titleTag: "isWebSocketsBlocked",
                correct: !DetectRTC.isWebSocketsBlocked,
            });
        },
        async getCameras() {
            let devices = await navigator.mediaDevices.enumerateDevices();
            let cameras = devices.filter((d) => d.kind === "videoinput");
            return cameras;
        },
        async getMicrophones() {
            let devices = await navigator.mediaDevices.enumerateDevices();
            let microphones = devices.filter((d) => d.kind === "audioinput");
            return microphones;
        },
        async join() {
            if (this.disabledAccess) return;

            this.loadingJoin = true;

            let user = null;
            if (!this.isLogged) {
                let identification =
                    this.identification !== ""
                        ? this.identification
                        : this.name;
                user = await RepositoryFactory.users.getUserInfo({
                    identifier: identification,
                });
                if (user === undefined) {
                    let response =
                        await RepositoryFactory.integration.getBioByRoom({
                            id: this.roomId,
                        });
                    let bioUser = response.data;

                    if (bioUser !== undefined && bioUser !== null) {
                        user = {
                            name: bioUser.fullName,
                        };
                    } else {
                        this.idError =
                            "No se encuentra el usuario con ese identificador";
                        return;
                    }
                }
                this.idError = "";
            } else {
                user = { name: this.name };
            }

            const userName = user.name;
            this.setConference({
                userName: userName,
                userIdentificationType: this.identificationType,
                userIdentification: this.identification,
                mediaStreamConstraints: this.mediaStreamConstraints,
            });

            var saved = await this.notifyPreRoomLeave();
            if (!saved) {
                return;
            }

            let processId = this.$route.query.processId;
            if (processId) {
                this.$router.push({
                    name: "conferenceRoom",
                    params: { roomId: this.roomId },
                    query: {
                        processId: processId,
                        cedula: this.$route.query.cedula,
                        environment: this.$route.query.environment,
                    },
                });
            } else {
                this.$router.push({
                    name: "conferenceRoom",
                    params: { roomId: this.roomId },
                    query: { require_auth: true },
                });
            }
        },
        async notifyPreRoomJoin() {
            if (this.isLogged) {
                await RepositoryFactory.operators.notifyJoinPreRoom({
                    roomId: this.roomId,
                });
            } else {
                await RepositoryFactory.onlineUser.notifyJoinPreRoom({
                    userId: this.$route.query.cedula,
                    processId: this.$route.query.processId,
                });
            }
        },
        async notifyPreRoomLeave() {
            if (this.isLogged) {
                try {
                    await RepositoryFactory.operators.notifyLeavePreRoom({
                        roomId: this.roomId,
                    });
                } catch {
                    this.showNotValidRoom = true;
                    return false;
                }
            } else {
                await RepositoryFactory.onlineUser.notifyLeavePreRoom({
                    userId: this.$route.query.cedula,
                    processId: this.$route.query.processId,
                });
            }
            return true;
        },
        async startMediaStream() {
            this.localStream = await navigator.mediaDevices.getUserMedia(
                this.mediaStreamConstraints
            );
        },
        stopMediaStream() {
            if (this.localStream !== null) {
                this.localStream = null;
                this.$refs.videoStream.stopCamera();
            }
        },
        async changeCamera() {
            this.stopMediaStream();
            if (this.mediaStreamConstraints.video !== undefined) {
                this.mediaStreamConstraints.video.deviceId = {
                    exact: this.cameraId,
                };
            }
            await this.startMediaStream();
        },
        async changeMicrophone() {
            this.stopMediaStream();
            if (this.mediaStreamConstraints.audio !== undefined) {
                this.mediaStreamConstraints.audio.deviceId = {
                    exact: this.microphoneId,
                };
            }

            await this.startMediaStream();
        },
        getStreamConstraints() {
            return this.mediaStreamConstraints;
        },
        toggleCamera() {
            this.enabledCamera = !this.enabledCamera;
            if (this.enabledCamera) {
                this.mediaStreamConstraints.video =
                    defaultMediaStreamConstraints.video;
            } else {
                delete this.mediaStreamConstraints.video;
            }
            this.changeCamera();
        },
        toggleMicrophone() {
            this.enabledMicrophone = !this.enabledMicrophone;
            if (this.enabledMicrophone) {
                this.mediaStreamConstraints.audio =
                    defaultMediaStreamConstraints.audio;
            } else {
                delete this.mediaStreamConstraints.audio;
            }
            this.changeMicrophone();
        },
    },
};
</script>

<style lang="scss" scoped>
.gradiend-background {
    //background-image: linear-gradient(75deg, #0ae9d6, #002ea8);
    background-image: url("../../assets/images/Banner-TE-CAU-Zertifica.jpg");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
}

.settings-column {
    width: 80%;
    margin-left: 10%;
    margin-top: 5%;
}
</style>